import React from "react";
import { AppBar, Button, ThemeProvider, Toolbar, createTheme } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import LanguageSwitcher from "../../shared/components/LanguageSwitcher";
import useTranslation from "../../shared/hooks/useTranslation";
import { AccountRoutePaths } from "../routes";
import { isComAppHost } from "../../shared/utils/hostPolicy";

const AccountHeader = () => {
  const { translate: tAccount } = useTranslation("account");
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const isOnSignIn = pathname.includes("/account/sign-in");
  const isOnSignUp = pathname.includes("/account/sign-up");

  const theme = createTheme({
    components: {
      MuiToolbar: {
        styleOverrides: {
          root: {
            background: "#fff",
            borderBottom: "1px solid #d5d6d9",
            paddingLeft: 16,
            paddingRight: 16,
            zIndex: 100
          }
        }
      }
    }
  });

  const renderAuthButton = () => {
    const qs = search || "";
    if (isOnSignIn) {
      // HOST_POLICY_SPEC §6 FE-B: no public self-registration on the `.com` app hosts, so the
      // "Register" button is not offered there. The reverse direction (Log in, below) stays on
      // every host — an invited `.com` user still needs it. `.cc` is unchanged.
      if (isComAppHost()) {
        return null;
      }

      return (
        <Button variant="outlined" onClick={() => navigate(`${AccountRoutePaths.signUp}${qs}`)}>{tAccount("registerButton")}</Button>
      );
    }
    if (isOnSignUp) {
      return (
        <Button variant="contained" onClick={() => navigate(`${AccountRoutePaths.signIn}${qs}`)}>{tAccount("loginButton")}</Button>
      );
    }
    return null;
  };

  return (
    <ThemeProvider theme={theme}>
      <AppBar position="static" elevation={0} sx={{ zIndex: 1250 }}>
        <Toolbar className="flex justify-end gap-4">
          <LanguageSwitcher />
          {renderAuthButton()}
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
};

export default AccountHeader;


